import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track } from "../../../../common/util/tealium";
import { IconRefresh } from "../../../../common/icons/IconRefresh/IconRefresh";
import defaultContent from "../../../../content/errorTile";
import "./ErrorTile.scss";

type Props = {
  clickFunction: () => void;
  errorStatus: boolean;
  isLoading: boolean;
  errorMessage?: string;
  btnText?: string;
  tealiumTrackId: string;
};

/**
 * DownlineProfile-local error tile. Mirrors the common ErrorTile API so it is a
 * drop-in within this feature, but renders the bordered "DS/Failure Card" style
 * (no chain icon): a centered message with an inline refresh "Try Again" link.
 */
export const ErrorTile = ({ clickFunction, errorStatus, isLoading, errorMessage, btnText, tealiumTrackId }: Props) => {
  const { t } = useTranslation(["errorTile"]);
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (errorStatus && !isLoading) {
      const page = `${pathname.replace("/", "")}${hash.length > 1 ? hash : ""}`;
      track("view", "", page, page, `errorTile__${tealiumTrackId}`);
    }
  }, [errorStatus, isLoading, pathname, hash, tealiumTrackId]);

  if (!errorStatus || isLoading) {
    return <></>;
  }

  return (
    <div className="DownlineProfileErrorTile" data-testid="downline-profile-error-tile">
      <p className="DownlineProfileErrorTile__error-msg">
        {errorMessage ? errorMessage : t("somethingWentWrong", defaultContent["somethingWentWrong"])}
      </p>
      <button
        type="button"
        className="DownlineProfileErrorTile__try-again-btn"
        onClick={() => clickFunction()}
        data-testid="downline-profile-error-tile-retry"
      >
        <span className="DownlineProfileErrorTile__try-again-icon">
          <IconRefresh color="blue" />
        </span>
        <span className="DownlineProfileErrorTile__try-again-text">
          {btnText ? btnText : t("tryAgain", defaultContent["tryAgain"])}
        </span>
      </button>
    </div>
  );
};
